import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import reportWebVitals from './reportWebVitals';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import routes from "./routes";
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from "./bodyComponent/Header";
import GlobalNavigationBar from "./bodyComponent/GlobalNavigationBar";
import Carousel from "./bodyComponent/Carousel";
import rootReducers from "./reducers/path";
import {configureStore} from "@reduxjs/toolkit";
import {Provider} from "react-redux";
import Footer from "./bodyComponent/Footer";
import BackOnTop from "./bodyComponent/BackOnTop";
import {GlobalContextProvider} from "./context/GlobalContext";
import {getConstantVersion} from "./util/util";

// 버전 정의
const version = getConstantVersion();
const root = ReactDOM.createRoot(document.getElementById(`root-${version}`));
const router = createBrowserRouter(routes);
const store = configureStore({
    reducer: rootReducers
});

root.render(
    <>
        {/*<div className='container header-container'>*/}
        <GlobalContextProvider>
            <div className='header-container'>
                <Header/>
            </div>
            <div className='gnb-container'>
                <GlobalNavigationBar/>
            </div>
            {/*<div className='c-body'>*/}
            {version === 1 && (
                <>
                    <div className='body-dom min-vh-100'>
                        <Carousel/>
                        <main className={'container'}>
                            <React.StrictMode>
                                <Provider store={store}>
                                    <RouterProvider router={router}/>
                                </Provider>
                            </React.StrictMode>
                        </main>
                    </div>
                    <Footer/>
                </>
            )}
            {version === 2 && (
                <>
                    <div className="body-dom d-flex flex-column min-vh-100">
                        <Carousel/>
                        <main className="container flex-grow-1">
                            <React.StrictMode>
                                <Provider store={store}>
                                    <RouterProvider router={router}/>
                                </Provider>
                            </React.StrictMode>
                        </main>
                        <Footer/>
                    </div>
                </>
            )}
            <BackOnTop/>
        </GlobalContextProvider>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
